// export let WEBOT_SERVER_ENDPOINT = "http://localhost:8080";
const retry = require('async-retry');

export type WebotConfig = {
  currentDomainServer: string;
};

export let WEBOT_SERVER_ENDPOINT = null;
(async () => {
  if (!WEBOT_SERVER_ENDPOINT) {
    WEBOT_SERVER_ENDPOINT =
      process.env.REACT_APP_WEBOT_SERVER_ENDPOINT ?? `https://api.webot.co.il`;
  }
})();

export const MAX_MESSAGES_IN_FREE_TRIAL = 100;
export const SUPPORT_CENTER_PHONE_NUMBER = '0534206477';
export const SUPPORT_CENTER_PHONE_NUMBER_INTL = '+972534206477';
export const SUPPORT_CENTER_PHONE_NUMBER_TEL_URL = `tel:${SUPPORT_CENTER_PHONE_NUMBER_INTL}`;
// wa.me expects the number in international format with no leading "+" or symbols.
export const SUPPORT_CENTER_WHATSAPP_URL = `https://wa.me/${SUPPORT_CENTER_PHONE_NUMBER_INTL.replace(
  /[^0-9]/g,
  ''
)}`;

// Agency-ambassador offer (campaign agency-ambassador-2026-12): an interested customer reaches
// Yarden directly, not the support line.
export const AGENCY_OFFER_CONTACT_PHONE_NUMBER_INTL = '+972525424499';
export const AGENCY_OFFER_CONTACT_PHONE_NUMBER_TEL_URL = `tel:${AGENCY_OFFER_CONTACT_PHONE_NUMBER_INTL}`;
export const AGENCY_OFFER_CONTACT_WHATSAPP_URL = `https://wa.me/${AGENCY_OFFER_CONTACT_PHONE_NUMBER_INTL.replace(
  /[^0-9]/g,
  ''
)}`;

export const BANNED_NUMBERS = [
  '+972586294352', // Kiril
  '+972525975730', // Molari
  '+972528907687', // Keren Levi
  '+972528071703',
  '+972533380073', // from Alex
  '+972547838385', // she threatened Ofer kleinman (tel aviv)
  '+972546847204', // עמית וורגפט
  '+972534626311' // want to sue customers
];
